<template>
  <v-dialog
    :value="true"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    transition="slide-y-reverse-transition"
    max-width="500"
    scrollable
    persistent
  >
    <PopupBannerForm
      :popupBanner="newPopupBanner"
      :errors="popupBannerValidationErrors"
      :disabled="savingPopupBanner"
      @clear:errors="clearPopupBannerValidationErrors"
      @cancel="$router.push({ name: 'popupBanners', query: popupBannerFilterParams })"
      @save="onSave"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PopupBannerForm from '../../components/PopupBannerForm';

export default {
  name: 'CreatePopupBanner',

  components: { PopupBannerForm },

  computed: mapState('popupBanners', [
    'newPopupBanner',
    'popupBannerValidationErrors',
    'savingPopupBanner',
    'popupBannerFilterParams',
  ]),

  methods: {
    ...mapActions('popupBanners', ['storePopupBanner', 'clearPopupBannerValidationErrors']),

    onSave(popupBanner) {
      this.storePopupBanner(popupBanner).then(() => {
        this.$router.push({ name: 'popupBanners', query: this.popupBannerFilterParams });
      });
    },
  },
};
</script>
